<template>
  <div class="project-viewer">
    <ProjectViewerSearchFilter />
    <ProjectViewerGrid v-if="allProjectsData" />
    <div v-if="!allProjectsData" class="loading-gliph-container">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";
import { getWork } from "@/utils/wpApiUtils";
import { arrayContainsArray } from "@/utils/miscUtils";
import ProjectViewerSearchFilter from "@/components/ProjectViewer/ProjectViewerSearchFilter/ProjectViewerSearchFilter";
import ProjectViewerGrid from "@/components/ProjectViewer/ProjectViewerGrid/ProjectViewerGrid";
export default {
  components: {
    ProjectViewerSearchFilter,
    ProjectViewerGrid
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions([
      "setAllProjectsData",
      "setProjectTextSearch",
      "setProjectTermFilters",
      "setProjectYearFilters",
      "setProjectStatusFilters"
    ]),
    handleTextInput(s) {
      this.setProjectTextSearch(s);
    },
    handleStatefulUrl(queries) {
      console.log(queries);

      if (queries["s"]) {
        this.setProjectTextSearch(decodeURI(queries["s"]));
      }

      if (queries["y"]) {
        const verify = queries => {
          if (!queries) {
            return false;
          }

          const array = queries.split(",");
          if (array.length === 2) {
            try {
              // update in 2040? who knows?
              if (parseInt(array[0]) >= 2000 && parseInt(array[1]) <= 2040) {
                return true;
              } else {
                return false;
              }
            } catch (err) {
              return false;
            }
          } else {
            return false;
          }
        };

        if (verify(queries["y"])) {
          const arr = queries["y"].split(",").map(n => parseInt(n));
          console.log("setting year queries");
          this.setProjectYearFilters(arr);
        }
      }

      if (queries["post_tag"]) {
        const array = queries["post_tag"].split(",").map(n => parseInt(n));
        const possibleTerms = this.taxonomies["post_tag"].map(el => el.term_id);
        const isVerified = arrayContainsArray(possibleTerms, array);
        if (isVerified) {
          this.setProjectTermFilters({
            ...this.projectTermFilters,
            post_tag: array
          });
        }
      }
      if (queries["service"]) {
        const array = queries["service"].split(",").map(n => parseInt(n));
        const possibleTerms = this.taxonomies["service"].map(el => el.term_id);
        const isVerified = arrayContainsArray(possibleTerms, array);
        if (isVerified) {
          this.setProjectTermFilters({
            ...this.projectTermFilters,
            service: array
          });
        }
      }
      if (queries["industry"]) {
        const array = queries["industry"].split(",").map(n => parseInt(n));
        const possibleTerms = this.taxonomies["industry"].map(el => el.term_id);
        const isVerified = arrayContainsArray(possibleTerms, array);
        if (isVerified) {
          this.setProjectTermFilters({
            ...this.projectTermFilters,
            industry: array
          });
        }
      }
      if (queries["subject-matter"]) {
        const array = queries["subject-matter"]
          .split(",")
          .map(n => parseInt(n));
        const possibleTerms = this.taxonomies["subject-matter"].map(
          el => el.term_id
        );
        const isVerified = arrayContainsArray(possibleTerms, array);
        if (isVerified) {
          this.setProjectTermFilters({
            ...this.projectTermFilters,
            "subject-matter": array
          });
        }
      }
      if (queries["technology"]) {
        const array = queries["technology"].split(",").map(n => parseInt(n));
        const possibleTerms = this.taxonomies["technology"].map(
          el => el.term_id
        );
        const isVerified = arrayContainsArray(possibleTerms, array);
        if (isVerified) {
          this.setProjectTermFilters({
            ...this.projectTermFilters,
            technology: array
          });
        }
      }

      if (queries["ex"]) {
        const newFilters = _.cloneDeep(this.projectStatusFilters);
        const queryArray = queries["ex"].split(",");

        queryArray.forEach(q => {
          if (Object.keys(newFilters).includes(q)) {
            const newEntry = _.cloneDeep(newFilters[q]);
            newEntry["isSelected"] = false;
            newFilters[q] = newEntry;
          }
        });

        this.setProjectStatusFilters(newFilters);
      }
    }
  },
  computed: {
    ...mapGetters([
      "allProjectsData",
      "projectTermFilters",
      "taxonomies",
      "projectView",
      "projectYearFilters",
      "projectStatusFilters"
    ])
  },
  mounted() {
    const queries = this.$route.query;
    this.handleStatefulUrl(queries);

    if (!this.allProjectsData) {
      getWork()
        .then(data => {
          const parsed = data.map(el => {
            return {
              ...el
              // title: el.post_title
            };
          });

          this.setAllProjectsData(parsed);
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.project-viewer {
  height: 100%;
  position: relative;
  // max-width: 1200px;
  // margin: 0 auto;
  // position: relative;
  // margin-top: 30px;

  .loading-gliph-container {
    margin-left: 350px;
    height: 100%;
    width: calc(100% - 350px);
    position: relative;
    display: flex;
    flex-flow: row;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    overflow-y: scroll;
    padding-top: 25px;
  }
}
</style>
